// extracted by mini-css-extract-plugin
export var measureBox = "_4s-0";